import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, restfulIO } from "./endpoint";

export interface Company extends AttributesMixin<typeof Company> { }

@define
export class Company extends Model {
    static endpoint = restfulIO('api/v1/company/companies');

    static attributes = {
        name: String,
        duns: String,
        isActive: Boolean,
        createdOn: Date,
        createdBy: String,
        updatedOn: Date,
        updatedBy: String,
        salesforceId: String,
        taxId: String
    }
}

export interface CompanyItem extends AttributesMixin<typeof CompanyItem> { }
@define
export class CompanyItem extends Model {
    static attributes = {
        name: String
    }
}

export interface Companies extends AttributesMixin<typeof Companies> { }
@define
export class Companies extends Model {
    static attributes = {
        items: [CompanyItem]
    }
}

export async function getCompanies(quicksearch?: string, companyId?: number): Promise<Companies> {
    let parameters = [
        quicksearch ? `quicksearch=${quicksearch}` : '',
        companyId ? `companyId=${companyId}` : ''
    ];

    let urlParameters = parameters.some(s => s !== '') ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/v1/company/companies/filter${urlParameters}`;
    return (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    })).json();
}

export const getCompaniesAsCommonParticipants = async (query) => {
    let response = await getCompanies(query);
    return (response ? response.items.map(x => ({ id: x.id, companyId: x.id, name: x.name })) : []);
}
